<script>
    import {_} from 'svelte-i18n';

    export let type;
</script>

{#if type === 'EA'}
    <div class="has-text-centered-mobile">{$_('type.ea')}</div>
{/if}
{#if type === 'GY'}
    <div class="has-text-centered-mobile">{$_('type.gy')}</div>
{/if}
{#if type === 'LA'}
    <div class="has-text-centered-mobile">{$_('type.la')}</div>
{/if}